import moment from 'moment/moment';

export interface HistoryQuery {
    query: string;
    timestamp: string;
    isExpanded: boolean;
}

export interface SavedQueriesType {
    query: string;
    timestamp: string;
}

export const saveQueryToLocalStorage = (
    queryKey: string,
    queries: SavedQueriesType[]
): void => {
    const encodedQueries = queries.map((item) => ({
        query: btoa(item.query),
        timestamp: item.timestamp,
    }));
    localStorage.setItem(queryKey, JSON.stringify(encodedQueries));
};

export const getQueryFromLocalStorage = (
    queryKey: string
): SavedQueriesType[] => {
    const storedQueries = localStorage.getItem(queryKey);
    if (storedQueries) {
        const encodedQueries = JSON.parse(storedQueries);
        return encodedQueries.map(
            (item: { query: string; timestamp: number }) => ({
                query: atob(item.query),
                timestamp: item.timestamp,
            })
        );
    }
    return [];
};

export const saveCurrentQuery = (queryKey: string, query: string): void => {
    const existingQueries = getQueryFromLocalStorage(queryKey);
    const existingQueryIndex = existingQueries.findIndex(
        (item: SavedQueriesType) => item.query === query
    );

    if (existingQueryIndex !== -1) {
        existingQueries.splice(existingQueryIndex, 1);
    }

    const newQueryItem: SavedQueriesType = {
        query,
        timestamp: moment().format('DD/MM/YYYY hh:mmA'),
    };
    existingQueries.unshift(newQueryItem);
    const limitedQueries = existingQueries.slice(0, 5);
    saveQueryToLocalStorage(queryKey, limitedQueries);
};
